import {
  startOfHour,
  endOfHour,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
} from 'date-fns';

export const WEEK_OPTIONS = { weekStartsOn: 1 as const }; // Monday

export type Gap =
  | '+1HOUR'
  | '+1DAY'
  | '+1WEEK'
  | '+1MONTH'
  | '+1QUARTER'
  | '+1YEAR';

export const getPeriodBounds = (dateValue: Date | number, gap: Gap) => {
  const d = new Date(dateValue);

  switch (gap) {
    case '+1HOUR':
      return { startDate: startOfHour(d), endDate: endOfHour(d) };

    case '+1DAY':
      return { startDate: startOfDay(d), endDate: endOfDay(d) };

    case '+1WEEK':
      return {
        startDate: startOfWeek(d, WEEK_OPTIONS),
        endDate: endOfWeek(d, WEEK_OPTIONS),
      };

    case '+1MONTH':
      return { startDate: startOfMonth(d), endDate: endOfMonth(d) };
    case '+1QUARTER':
      return { startDate: startOfQuarter(d), endDate: endOfQuarter(d) };

    case '+1YEAR':
      return { startDate: startOfYear(d), endDate: endOfYear(d) };

    default:
      // Fallback to day if something unexpected comes in
      return { startDate: startOfDay(d), endDate: endOfDay(d) };
  }
};
export const toUnix = (date: Date): number => Math.floor(date.getTime() / 1000);
export const fromUnix = (unix: number): Date => new Date(unix * 1000);
export function logInfoWithTime(...args) {
  const time = new Date().toLocaleString('en-GB', { timeZoneName: 'short' });
  console.log(`[${time}]`, ...args);
}

export function logErrorWithTime(...args) {
  const time = new Date().toLocaleString('en-GB', { timeZoneName: 'short' });
  console.error(`[${time}]`, ...args);
}
